import {CommonModule} from '@angular/common';
import {Component, OnInit, forwardRef, Input, Output, EventEmitter} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormBuilder, FormControl,
  FormGroup,
  FormsModule,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
  Validators
} from '@angular/forms';
import {AppCommonModule} from '@app/components/app.common.module';
import {
  InsuranceType,
  optionsInsuranceType
} from "@app/pages/quote/standard-quote/catalogs/financial-setup/new-financial-setup/components/insurance-parametrics/insurance-form/InsuranceConfig";
import {StandardFinancialSetupAttribute} from "@app/pages/quote/standard-quote/model/financial-setup.model";

@Component({
  selector: 'app-insurance-form',
  standalone: true,
  templateUrl: './insurance-form.component.html',
  styleUrls: ['./insurance-form.component.css'],

  imports: [FormsModule, AppCommonModule, CommonModule,],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InsuranceFormComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InsuranceFormComponent),
      multi: true,
    },
  ],
})
export class InsuranceFormComponent implements OnInit, ControlValueAccessor, Validator {
  form: FormGroup;
  optionsInsuranceType = optionsInsuranceType
  @Input() insuranceType: string = "";
  @Output() insuranceTypeChange = new EventEmitter<string>();
  @Input() isReadyToEdit: boolean;

  constructor(private fb: FormBuilder,) {
    this.createForm();
  }

  ngOnInit() {
    if (this.insuranceType && this.insuranceType.length > 0) {
      this.updateForm();
    } else {
      this.createForm();
    }
  }

  ngOnChanges() {
    if (this.insuranceType && this.insuranceType.length > 0) {
      this.updateForm();
    }
  }


  findInsuranceType(value: string) {
    const splitInsuranceType = this.insuranceType.split(',');
    return splitInsuranceType.find(item => item === value);
  }

  updateForm() {
    this.form = this.fb.group({
      annualPayment: new FormControl(this.findInsuranceType(InsuranceType.COUNTED_ANNUAL), []),
      annualFinanced: [this.findInsuranceType(InsuranceType.FINANCED_ANNUAL), []],
      multiAnnualPayment: [this.findInsuranceType(InsuranceType.COUNTED_MULTIYEAR), []],
      multiAnnualFinanced: [this.findInsuranceType(InsuranceType.FINANCED_MULTIYEAR), []],
      clientAccount: [this.findInsuranceType(InsuranceType.CLIENT), []],
      noInsurance: [this.findInsuranceType(InsuranceType.NOT_INSURANCE), []],
      lifePayment: [this.findInsuranceType(InsuranceType.COUNTED_LIFE), []],
      lifeFinanced: [this.findInsuranceType(InsuranceType.FINANCED_LIFE), []],
    });
  }

  createForm() {
    this.form = this.fb.group({
      annualPayment: [null, []],
      annualFinanced: [null, []],
      multiAnnualPayment: [null, []],
      multiAnnualFinanced: [null, []],
      clientAccount: [null, []],
      noInsurance: [null, []],
      lifePayment: [null, []],
      lifeFinanced: [null, []],
    });
    this.form.valueChanges.subscribe((value) => {
      this.onChange(value);
      this.onTouched();
    });
  }


  writeValue(value: any): void {
    if (value) {
      this.form.patchValue(value, {emitEvent: false});
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  private onChange = (_: any) => {
  };
  private onTouched = () => {
  };

  validate(_control: AbstractControl<any, any>): ValidationErrors | null {
    return this.form.valid ? null : {invalidFormCustomer: true};
  }

  addInsuranceType(value: string) {
    if (!this.insuranceType) this.insuranceType = "";
    if (!value) return
    if (!this.insuranceType.includes(value)) {
      this.insuranceType = this.insuranceType + "," + value;
    }
  }

  deleteInsuranceType(value: string) {
    if (!value) return
    let splitInsuranceType = this.insuranceType.split(',');
    //remove the value from the array splitInsuranceType
    splitInsuranceType = splitInsuranceType.filter(item => item !== value);
    //join the array back to string
    this.insuranceType = splitInsuranceType.join(',');
  }


  onInsuranceTypeChange(event: any, controlName: string, value: string) {
    if (event.target.checked) {
      this.form.controls[controlName].setValue(InsuranceType[value as keyof typeof InsuranceType]);
      this.addInsuranceType(value);
      this.insuranceTypeChange.emit(this.insuranceType);
    } else {
      this.form.controls[controlName].setValue(InsuranceType.NONE);
      this.deleteInsuranceType(value);
      this.insuranceTypeChange.emit(this.insuranceType);
    }
  }

}


